import {useNavigate} from 'react-router-dom';
import DOMPurify from 'dompurify';
import {
  SoopButtonCommon,
  SoopLayer,
  SoopLayerContent,
  useDialogContext,
  SoopLayerFooter,
} from '@soop-ui/soop-ui';
import {ROUTE} from '@/constants/main/route';
import {HELP_LOG} from '@/constants/help';
import {useGetFaqBody} from '@/hooks/help';
import {sendHelpClickLog} from '@/utils/help/log';
import SectionLoading from '@/components/help/common/SectionLoading';
import styles from './QuestionLayer.module.scss';

interface QuestionLayerProps {
  isMobile: boolean;
  questionId: string;
  title: string;
}

const QuestionLayer = ({isMobile, questionId, title}: QuestionLayerProps) => {
  const navigate = useNavigate();
  const {data, isLoading} = useGetFaqBody({enabled: true, questionId});
  const {close} = useDialogContext();

  const handleCancel = () => {
    close(false);
  };

  const navigateToQuestion = () => {
    navigate(`${ROUTE.HELP.FAQ}/${questionId}`, {replace: true});
    sendHelpClickLog(HELP_LOG.CODE_TYPE.MAIN_CONTENTS, {
      buttonType: HELP_LOG.BUTTON_TYPE.FAQ,
      actionType: HELP_LOG.ACTION_TYPE.TO_SELECT,
    });
  };

  return (
    <SoopLayer onClose={handleCancel} size='lg'>
      <SoopLayerContent>
        <div className={styles.QuestionWrapper}>
          <div className={styles.Title}>
            <em>Q</em>
            <span>{data?.title || title}</span>
          </div>
          {isLoading ? (
            <SectionLoading isMobile={isMobile} pcHeight={420} />
          ) : (
            <div className={styles.Content}>
              <em>A</em>
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(data?.contents || '', {
                    ADD_ATTR: ['target'],
                  }),
                }}
              />
            </div>
          )}
        </div>
      </SoopLayerContent>
      {isMobile ? (
        <SoopLayerFooter
          primaryLabel='해당 질문 바로가기'
          onPrimaryClick={navigateToQuestion}
          secondaryLabel='확인'
          onSecondaryClick={handleCancel}
        />
      ) : (
        <SoopButtonCommon
          endIconName='icoChevronSmallLeft'
          onClick={navigateToQuestion}
          size={52}
          variant='lineSecondary'>
          해당 질문 바로가기
        </SoopButtonCommon>
      )}
    </SoopLayer>
  );
};
export default QuestionLayer;
